import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { setDeviceId } from "../utils/deviceAuth";
import { registerAdmin } from "../utils/api";

const PostAndRedirect = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const sendData = async () => {
      try {
        const otp = id;

        const response = await registerAdmin({ otp });

        if (response.status === 201) {
          const deviceId = response?.data?.deviceId;
          if (deviceId) {
            setDeviceId(deviceId);
          }
        }
      } catch (error) {
        console.error("Error during POST request:", error);
      } finally {
        navigate("/");
      }
    };

    sendData();
  }, []);

  return null;
};

export default PostAndRedirect;
